import { brandColors } from '../../styles/variables';

const initialState = {
  screens: []
};

initialState.screens.featureScreen = {
  side1: {
    background: brandColors.lightblue,
    lineText: brandColors.blue,
    side2: {
      background: brandColors.blue,
      lineText: brandColors.lightblue
    },
    hovered: true
  },
  side2: {
    background: brandColors.orange,
    lineText: brandColors.blue,
    side1: {
      background: brandColors.blue,
      lineText: brandColors.orange
    },
    hovered: false
  }
};

export default initialState;



// WEBPACK FOOTER //
// ./src/pages/Home/initialState.js